// extracted by mini-css-extract-plugin
module.exports = {"menu":"SidebarMenu_menu__3tkOu"};